import { Flex } from 'antd'
import React, { } from 'react'

import {
  vaultMediaTypeOptions,
  VaultMediaTypeOptionValue,
} from '@/model/vault'

import RadioButtons from '../radio-buttons'

import s from './vault-media-search-bar.module.css'

export interface VaultMediaSearchBarProps {
  mediaType: VaultMediaTypeOptionValue
  onMediaTypeChange: (type: VaultMediaTypeOptionValue) => void
}

export default function VaultMediaSearchBar({
  mediaType,
  onMediaTypeChange,
}: VaultMediaSearchBarProps) {
  return (
    <Flex className={s.SearchBar}>
      <RadioButtons
        className={s.TypeFilter}
        options={vaultMediaTypeOptions}
        value={mediaType}
        onChange={onMediaTypeChange}
      />
    </Flex>
  )
}
